import React from 'react';
import usePageVisibility from '../utilities/use-page-visibility';

export const SettingsStateContext = React.createContext({});
export const SettingsDispatchContext = React.createContext(() => {});
export const SettingsStoreContext = React.createContext({});

export const defaultServiceId__ = 'mmDefaultServiceId__';
export const serviceMode__ = 'mmServiceMode__';
const getState = (store) => {
    const defaultServiceId = store.get(defaultServiceId__);
    const defaultMode = store.get(serviceMode__);
    const state = {
        defaultServiceId,
        defaultMode
    };
    return state;
};

export const SettingsProvider = React.memo(({children, store}) => {
    const [state, setState] = React.useState(() => getState(store));
    const onVisibilityChange = React.useCallback((visible) => {
        if (visible) {
            setState(getState(store));
        }
    }, []);
    usePageVisibility(onVisibilityChange);
    const dispatch = React.useCallback(() => {
        setState(getState(store));
    }, []);
    return (
        <SettingsStoreContext.Provider value={store}>
            <SettingsStateContext.Provider value={state}>
                <SettingsDispatchContext.Provider value={dispatch}>
                    {children}
                </SettingsDispatchContext.Provider>
            </SettingsStateContext.Provider>
        </SettingsStoreContext.Provider>
    );
});

export const useSettingsState = () => React.useContext(SettingsStateContext);
export const useSettingsDispatch = () => React.useContext(SettingsDispatchContext);
export const useSettingsStore = () => React.useContext(SettingsStoreContext);